import { Text } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { ProjectIdCell } from "../components/ProjectIdCell";
import { DueDateCell } from "../components/DueDateCell";
import { StatusCell } from "../components/StatusCell";
import { TranslationTypeCell } from "../components/TranslationTypeCell";
import { LanguagesCell } from "../components/LanguagesCell";
import { ManagerCell } from "../components/ManagerCell";
import { TranslatorCell } from "../components/TranslatorCell";
import { MessageCell } from "../components/MessageCell";
import { ActionCell } from "../components/ActionCell";
import { TransformedProjectData, UnreadMessage } from "../types";

const columnHelper = createColumnHelper<TransformedProjectData>();

export const createProjectsTableColumns = (
  textColor: string,
  unreadMessages: UnreadMessage[],
  onShowProjectDetails: (projectId: string) => void
) => [
  columnHelper.accessor("id", {
    id: "id",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Project #
      </Text>
    ),
    cell: (info) => (
      <ProjectIdCell
        id={info.getValue()}
        textColor={textColor}
        userId={info.row.original?.user_id}
      />
    ),
  }),
  columnHelper.accessor("order_due_at", {
    id: "order_due_at",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Due Date
      </Text>
    ),
    cell: (info) => (
      <DueDateCell dueDate={info.getValue()} textColor={textColor} />
    ),
  }),
  columnHelper.accessor("order_status_name", {
    id: "order_status_name",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Status
      </Text>
    ),
    cell: (info) => (
      <StatusCell status={info.getValue()} textColor={textColor} />
    ),
  }),
  columnHelper.accessor("translation_type", {
    id: "translation_type",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Translation Type
      </Text>
    ),
    cell: (info) => (
      <TranslationTypeCell translationType={info.getValue()} textColor={textColor} />
    ),
  }),
  columnHelper.accessor("languages", {
    id: "languages",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Languages
      </Text>
    ),
    cell: (info) => (
      <LanguagesCell
        translatedFrom={info.row.original?.translated_from}
        translatedTo={info.row.original?.translated_to}
        textColor={textColor}
      />
    ),
  }),
  columnHelper.accessor("managers", {
    id: "managers",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      >
        Manager
      </Text>
    ),
    cell: (info) => (
      <ManagerCell managers={info.getValue()} textColor={textColor} />
    ),
  }),
  columnHelper.accessor("translator", {
    id: "translator",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        color="gray.500"
        fontWeight="400"
      >
        Translator(s)
      </Text>
    ),
    cell: (info) => (
      <TranslatorCell translators={info.getValue()} textColor={textColor} />
    ),
  }),
  columnHelper.accessor("message_cnt", {
    id: "message_cnt",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        fontWeight="400"
        color="gray.500"
      ></Text>
    ),
    cell: (info) => (
      <MessageCell
        projectId={Number(info.row.original.id)}
        unreadMessages={unreadMessages}
      />
    ),
  }),
  columnHelper.accessor("actionCol", {
    id: "actionCol",
    header: () => (
      <Text
        justifyContent="space-between"
        align="center"
        fontSize={{ sm: "10px", lg: "12px" }}
        lineHeight="24px"
        color="gray.500"
        fontWeight="400"
      ></Text>
    ),
    cell: (info) => (
      <ActionCell
        orderId={info.row.original.order_id}
        includeExpeditedTurnaround={info.row.original.include_expedited_turnaround}
        orderStatusId={info.row.original.order_status_id}
        onShowProjectDetails={onShowProjectDetails}
      />
    ),
  }),
];
